const dateToTimezone = require("app/util/formatter/text.js").dateToTimezone;

const dateToParam = function(date) {
  return date.format("YYYY-MM-DD HH:mm:ss");
}

const dateToUTCParam = function(date) {
  return dateToParam(dateToTimezone(date, window.loggedUserTzId, "UTC"));
}

module.exports = { dateToParam, dateToUTCParam };



// WEBPACK FOOTER //
// ./app/screens/Dashboard/actions/util/date-to-param.js